import { Modal, Button } from 'gokwik-ui-kit'

export const DocumentPreviewModal = ({ visible, onClose, documentUrl, documentName }) => {
    const handleDownload = async () => {
        try {
            const response = await fetch(documentUrl)
            const blob = await response.blob()

            const blobUrl = window.URL.createObjectURL(blob)

            const link = document.createElement('a')
            link.href = blobUrl
            link.download = documentName || 'document'

            document.body.appendChild(link)
            link.click()

            setTimeout(() => {
                document.body.removeChild(link)
                window.URL.revokeObjectURL(blobUrl)
            }, 100)
        } catch (error) {
            console.error('Download failed:', error)
            window.open(documentUrl, '_blank')
        }
    }

    const isPdf = (input) => {
        function extractFileName(url) {
            const urlObj = new URL(url)
            const pathname = urlObj.pathname // e.g., "/onboarding/2018/aus_pan_card.pdf"
            return pathname.substring(pathname.lastIndexOf('/') + 1)
        }

        const fileName = extractFileName(input)

        return fileName.includes('.pdf')
    }

    return (
        <Modal title='Document Preview' visible={visible} onCancel={onClose} footer={null} width={800}>
            {isPdf(documentUrl) ? (
                <iframe
                    src={documentUrl}
                    style={{ width: '100%', height: '500px', border: 'none' }}
                    title='Document Preview'
                />
            ) : (
                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    <img
                        src={documentUrl}
                        style={{ width: '100%', height: 'auto', border: 'none' }}
                        title='Document Preview'
                    />
                </div>
            )}

            <div className='flex justify-end mt-2'>
                <Button variant='primary' onClick={async () => await handleDownload()}>
                    Download
                </Button>
            </div>
        </Modal>
    )
}
